; (() => {
  /* eslint-disable */
  var getRandomValues
  var rnds8 = new Uint8Array(16)

  function rng() {
    if (!getRandomValues) {
      getRandomValues =
        (typeof crypto !== 'undefined' &&
          crypto.getRandomValues &&
          crypto.getRandomValues.bind(crypto)) ||
        (typeof msCrypto !== 'undefined' &&
          typeof msCrypto.getRandomValues === 'function' &&
          msCrypto.getRandomValues.bind(msCrypto))
      if (!getRandomValues) {
        throw new Error(
          'crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported'
        )
      }
    }
    return getRandomValues(rnds8)
  }

  var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i

  function validate(uuid) {
    return typeof uuid === 'string' && REGEX.test(uuid)
  }

  var byteToHex = []
  for (var i = 0; i < 256; ++i) {
    byteToHex.push((i + 256).toString(16).substr(1))
  }

  function stringify(arr) {
    var offset =
      arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0
    var uuid = (
      byteToHex[arr[offset + 0]] +
      byteToHex[arr[offset + 1]] +
      byteToHex[arr[offset + 2]] +
      byteToHex[arr[offset + 3]] +
      '-' +
      byteToHex[arr[offset + 4]] +
      byteToHex[arr[offset + 5]] +
      '-' +
      byteToHex[arr[offset + 6]] +
      byteToHex[arr[offset + 7]] +
      '-' +
      byteToHex[arr[offset + 8]] +
      byteToHex[arr[offset + 9]] +
      '-' +
      byteToHex[arr[offset + 10]] +
      byteToHex[arr[offset + 11]] +
      byteToHex[arr[offset + 12]] +
      byteToHex[arr[offset + 13]] +
      byteToHex[arr[offset + 14]] +
      byteToHex[arr[offset + 15]]
    ).toLowerCase()
    if (!validate(uuid)) {
      throw TypeError('Stringified UUID is invalid')
    }
    return uuid
  }

  var _nodeId
  var _clockseq
  var _lastMSecs = 0
  var _lastNSecs = 0

  function v1(options, buf, offset) {
    var i = (buf && offset) || 0
    var b = buf || new Array(16)
    options = options || {}
    var node = options.node || _nodeId
    var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq
    if (node == null || clockseq == null) {
      var seedBytes = options.random || (options.rng || rng)()
      if (node == null) {
        node = _nodeId = [
          seedBytes[0] | 1,
          seedBytes[1],
          seedBytes[2],
          seedBytes[3],
          seedBytes[4],
          seedBytes[5]
        ]
      }
      if (clockseq == null) {
        clockseq = _clockseq = ((seedBytes[6] << 8) | seedBytes[7]) & 16383
      }
    }
    var msecs = options.msecs !== void 0 ? options.msecs : Date.now()
    var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4
    if (dt < 0 && options.clockseq === void 0) {
      clockseq = (clockseq + 1) & 16383
    }
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
      nsecs = 0
    }
    if (nsecs >= 1e4) {
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec")
    }
    _lastMSecs = msecs
    _lastNSecs = nsecs
    _clockseq = clockseq
    msecs += 122192928e5
    var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296
    b[i++] = (tl >>> 24) & 255
    b[i++] = (tl >>> 16) & 255
    b[i++] = (tl >>> 8) & 255
    b[i++] = tl & 255
    var tmh = ((msecs / 4294967296) * 1e4) & 268435455
    b[i++] = (tmh >>> 8) & 255
    b[i++] = tmh & 255
    b[i++] = ((tmh >>> 24) & 15) | 16
    b[i++] = (tmh >>> 16) & 255
    b[i++] = (clockseq >>> 8) | 128
    b[i++] = clockseq & 255
    for (var n = 0; n < 6; ++n) {
      b[i + n] = node[n]
    }
    return buf || stringify(b)
  }

  function parse(uuid) {
    if (!validate(uuid)) {
      throw TypeError('Invalid UUID')
    }
    var v
    var arr = new Uint8Array(16)
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24
    arr[1] = (v >>> 16) & 255
    arr[2] = (v >>> 8) & 255
    arr[3] = v & 255
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8
    arr[5] = v & 255
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8
    arr[7] = v & 255
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8
    arr[9] = v & 255
    arr[10] = ((v = parseInt(uuid.slice(24, 36), 16)) / 1099511627776) & 255
    arr[11] = (v / 4294967296) & 255
    arr[12] = (v >>> 24) & 255
    arr[13] = (v >>> 16) & 255
    arr[14] = (v >>> 8) & 255
    arr[15] = v & 255
    return arr
  }

  function stringToBytes(str) {
    str = unescape(encodeURIComponent(str))
    var bytes = []
    for (var i = 0; i < str.length; ++i) {
      bytes.push(str.charCodeAt(i))
    }
    return bytes
  }

  var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8'
  var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'

  function v35(name, version2, hashfunc) {
    function generateUUID(value, namespace, buf, offset) {
      if (typeof value === 'string') {
        value = stringToBytes(value)
      }
      if (typeof namespace === 'string') {
        namespace = parse(namespace)
      }
      if (namespace.length !== 16) {
        throw TypeError(
          'Namespace must be array-like (16 iterable integer values, 0-255)'
        )
      }
      var bytes = new Uint8Array(16 + value.length)
      bytes.set(namespace)
      bytes.set(value, namespace.length)
      bytes = hashfunc(bytes)
      bytes[6] = (bytes[6] & 15) | version2
      bytes[8] = (bytes[8] & 63) | 128
      if (buf) {
        offset = offset || 0
        for (var i = 0; i < 16; ++i) {
          buf[offset + i] = bytes[i]
        }
        return buf
      }
      return stringify(bytes)
    }

    try {
      generateUUID.name = name
    } catch (err) { }
    generateUUID.DNS = DNS
    generateUUID.URL = URL
    return generateUUID
  }

  function md5(bytes) {
    if (typeof bytes === 'string') {
      var msg = unescape(encodeURIComponent(bytes))
      bytes = new Uint8Array(msg.length)
      for (var i = 0; i < msg.length; ++i) {
        bytes[i] = msg.charCodeAt(i)
      }
    }
    return md5ToHexEncodedArray(
      wordsToMd5(bytesToWords(bytes), bytes.length * 8)
    )
  }

  function md5ToHexEncodedArray(input) {
    var output = []
    var length32 = input.length * 32
    var hexTab = '0123456789abcdef'
    for (var i = 0; i < length32; i += 8) {
      var x = (input[i >> 5] >>> i % 32) & 255
      var hex = parseInt(
        hexTab.charAt((x >>> 4) & 15) + hexTab.charAt(x & 15),
        16
      )
      output.push(hex)
    }
    return output
  }

  function getOutputLength(inputLength8) {
    return (((inputLength8 + 64) >>> 9) << 4) + 14 + 1
  }

  function wordsToMd5(x, len) {
    x[len >> 5] |= 128 << len % 32
    x[getOutputLength(len) - 1] = len
    var a = 1732584193
    var b = -271733879
    var c = -1732584194
    var d = 271733878
    for (var i = 0; i < x.length; i += 16) {
      var olda = a
      var oldb = b
      var oldc = c
      var oldd = d
      a = md5ff(a, b, c, d, x[i], 7, -680876936)
      d = md5ff(d, a, b, c, x[i + 1], 12, -389564586)
      c = md5ff(c, d, a, b, x[i + 2], 17, 606105819)
      b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330)
      a = md5ff(a, b, c, d, x[i + 4], 7, -176418897)
      d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426)
      c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341)
      b = md5ff(b, c, d, a, x[i + 7], 22, -45705983)
      a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416)
      d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417)
      c = md5ff(c, d, a, b, x[i + 10], 17, -42063)
      b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162)
      a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682)
      d = md5ff(d, a, b, c, x[i + 13], 12, -40341101)
      c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290)
      b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329)
      a = md5gg(a, b, c, d, x[i + 1], 5, -165796510)
      d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632)
      c = md5gg(c, d, a, b, x[i + 11], 14, 643717713)
      b = md5gg(b, c, d, a, x[i], 20, -373897302)
      a = md5gg(a, b, c, d, x[i + 5], 5, -701558691)
      d = md5gg(d, a, b, c, x[i + 10], 9, 38016083)
      c = md5gg(c, d, a, b, x[i + 15], 14, -660478335)
      b = md5gg(b, c, d, a, x[i + 4], 20, -405537848)
      a = md5gg(a, b, c, d, x[i + 9], 5, 568446438)
      d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690)
      c = md5gg(c, d, a, b, x[i + 3], 14, -187363961)
      b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501)
      a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467)
      d = md5gg(d, a, b, c, x[i + 2], 9, -51403784)
      c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473)
      b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734)
      a = md5hh(a, b, c, d, x[i + 5], 4, -378558)
      d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463)
      c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562)
      b = md5hh(b, c, d, a, x[i + 14], 23, -35309556)
      a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060)
      d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353)
      c = md5hh(c, d, a, b, x[i + 7], 16, -155497632)
      b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640)
      a = md5hh(a, b, c, d, x[i + 13], 4, 681279174)
      d = md5hh(d, a, b, c, x[i], 11, -358537222)
      c = md5hh(c, d, a, b, x[i + 3], 16, -722521979)
      b = md5hh(b, c, d, a, x[i + 6], 23, 76029189)
      a = md5hh(a, b, c, d, x[i + 9], 4, -640364487)
      d = md5hh(d, a, b, c, x[i + 12], 11, -421815835)
      c = md5hh(c, d, a, b, x[i + 15], 16, 530742520)
      b = md5hh(b, c, d, a, x[i + 2], 23, -995338651)
      a = md5ii(a, b, c, d, x[i], 6, -198630844)
      d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415)
      c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905)
      b = md5ii(b, c, d, a, x[i + 5], 21, -57434055)
      a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571)
      d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606)
      c = md5ii(c, d, a, b, x[i + 10], 15, -1051523)
      b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799)
      a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359)
      d = md5ii(d, a, b, c, x[i + 15], 10, -30611744)
      c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380)
      b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649)
      a = md5ii(a, b, c, d, x[i + 4], 6, -145523070)
      d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379)
      c = md5ii(c, d, a, b, x[i + 2], 15, 718787259)
      b = md5ii(b, c, d, a, x[i + 9], 21, -343485551)
      a = safeAdd(a, olda)
      b = safeAdd(b, oldb)
      c = safeAdd(c, oldc)
      d = safeAdd(d, oldd)
    }
    return [a, b, c, d]
  }

  function bytesToWords(input) {
    if (input.length === 0) {
      return []
    }
    var length8 = input.length * 8
    var output = new Uint32Array(getOutputLength(length8))
    for (var i = 0; i < length8; i += 8) {
      output[i >> 5] |= (input[i / 8] & 255) << i % 32
    }
    return output
  }

  function safeAdd(x, y) {
    var lsw = (x & 65535) + (y & 65535)
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16)
    return (msw << 16) | (lsw & 65535)
  }

  function bitRotateLeft(num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt))
  }

  function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b)
  }

  function md5ff(a, b, c, d, x, s, t) {
    return md5cmn((b & c) | (~b & d), a, b, x, s, t)
  }

  function md5gg(a, b, c, d, x, s, t) {
    return md5cmn((b & d) | (c & ~d), a, b, x, s, t)
  }

  function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t)
  }

  function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t)
  }

  var v3 = v35('v3', 48, md5)

  function v4(options, buf, offset) {
    options = options || {}
    var rnds = options.random || (options.rng || rng)()
    rnds[6] = (rnds[6] & 15) | 64
    rnds[8] = (rnds[8] & 63) | 128
    if (buf) {
      offset = offset || 0
      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = rnds[i]
      }
      return buf
    }
    return stringify(rnds)
  }

  function f(s, x, y, z) {
    switch (s) {
      case 0:
        return (x & y) ^ (~x & z)
      case 1:
        return x ^ y ^ z
      case 2:
        return (x & y) ^ (x & z) ^ (y & z)
      case 3:
        return x ^ y ^ z
    }
  }

  function ROTL(x, n) {
    return (x << n) | (x >>> (32 - n))
  }

  function sha1(bytes) {
    var K = [1518500249, 1859775393, 2400959708, 3395469782]
    var H = [1732584193, 4023233417, 2562383102, 271733878, 3285377520]
    if (typeof bytes === 'string') {
      var msg = unescape(encodeURIComponent(bytes))
      bytes = []
      for (var i = 0; i < msg.length; ++i) {
        bytes.push(msg.charCodeAt(i))
      }
    } else if (!Array.isArray(bytes)) {
      bytes = Array.prototype.slice.call(bytes)
    }
    bytes.push(128)
    var l = bytes.length / 4 + 2
    var N = Math.ceil(l / 16)
    var M = new Array(N)
    for (var _i = 0; _i < N; ++_i) {
      var arr = new Uint32Array(16)
      for (var j = 0; j < 16; ++j) {
        arr[j] =
          (bytes[_i * 64 + j * 4] << 24) |
          (bytes[_i * 64 + j * 4 + 1] << 16) |
          (bytes[_i * 64 + j * 4 + 2] << 8) |
          bytes[_i * 64 + j * 4 + 3]
      }
      M[_i] = arr
    }
    M[N - 1][14] = ((bytes.length - 1) * 8) / Math.pow(2, 32)
    M[N - 1][14] = Math.floor(M[N - 1][14])
    M[N - 1][15] = ((bytes.length - 1) * 8) & 4294967295
    for (var _i2 = 0; _i2 < N; ++_i2) {
      var W = new Uint32Array(80)
      for (var t = 0; t < 16; ++t) {
        W[t] = M[_i2][t]
      }
      for (var _t = 16; _t < 80; ++_t) {
        W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1)
      }
      var a = H[0]
      var b = H[1]
      var c = H[2]
      var d = H[3]
      var e = H[4]
      for (var _t2 = 0; _t2 < 80; ++_t2) {
        var s = Math.floor(_t2 / 20)
        var T = (ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2]) >>> 0
        e = d
        d = c
        c = ROTL(b, 30) >>> 0
        b = a
        a = T
      }
      H[0] = (H[0] + a) >>> 0
      H[1] = (H[1] + b) >>> 0
      H[2] = (H[2] + c) >>> 0
      H[3] = (H[3] + d) >>> 0
      H[4] = (H[4] + e) >>> 0
    }
    return [
      (H[0] >> 24) & 255,
      (H[0] >> 16) & 255,
      (H[0] >> 8) & 255,
      H[0] & 255,
      (H[1] >> 24) & 255,
      (H[1] >> 16) & 255,
      (H[1] >> 8) & 255,
      H[1] & 255,
      (H[2] >> 24) & 255,
      (H[2] >> 16) & 255,
      (H[2] >> 8) & 255,
      H[2] & 255,
      (H[3] >> 24) & 255,
      (H[3] >> 16) & 255,
      (H[3] >> 8) & 255,
      H[3] & 255,
      (H[4] >> 24) & 255,
      (H[4] >> 16) & 255,
      (H[4] >> 8) & 255,
      H[4] & 255
    ]
  }

  var v5 = v35('v5', 80, sha1)
  var nil = '00000000-0000-0000-0000-000000000000'

  function version(uuid) {
    if (!validate(uuid)) {
      throw TypeError('Invalid UUID')
    }
    return parseInt(uuid.substr(14, 1), 16)
  }

  window.BAO.UUID = {
    v1,
    v3,
    v4,
    v5
  }
})()
